<div
  class="prescription-demo-main"
  (click)="onShowHideDemoPrescription()"
  *ngIf="showHideDemoPrescription"
>
  <div class="prescription-demo-img" (click)="$event.stopPropagation()">
    <div class="prescription-area-top">
      <h2>Prescriptions</h2>

      <div class="cross-icon" (click)="onShowHideDemoPrescription()">
        <i class="fa-solid fa-xmark"></i>
      </div>
    </div>

    <img
      src="./assets/images/temp/prescription/prescription.webp"
      alt="prescription-image"
    />
  </div>
</div>
